var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telegram_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z",
    fill: "url(#telegram_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.123 12.877 1.424 3.94s.178.37.368.37 3.026-2.95 3.026-2.95l3.152-6.089-7.92 3.712-.05 1.017Z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.01 13.888-.273 2.904s-.114.89.776 0 1.741-1.576 1.741-1.576",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.149 13.018-2.929-.954s-.35-.142-.237-.464c.023-.067.07-.123.21-.22.649-.453 12.01-4.536 12.01-4.536s.321-.109.51-.037a.277.277 0 0 1 .189.206c.02.084.029.171.025.258 0 .076-.01.145-.017.255-.069 1.116-2.14 9.449-2.14 9.449s-.123.487-.567.504a.815.815 0 0 1-.593-.229c-.871-.75-3.882-2.773-4.547-3.218a.128.128 0 0 1-.055-.09c-.009-.047.042-.105.042-.105s5.243-4.66 5.382-5.149c.01-.038-.03-.057-.085-.04-.348.128-6.384 3.94-7.05 4.36a.321.321 0 0 1-.148.01Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "telegram_svg__b",
    x1: 12,
    y1: 24,
    x2: 12,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "telegram_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgTelegram;